<template>
  <v-container>
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h6">Profiling Questions</span>
        <div>
          <v-btn color="primary" class="mr-2" @click="navigateToQuestionForm">
            Add Question
          </v-btn>
          <v-btn class="mr-2" @click="navigateToAnalytics" color="primary" dark>
            Analytics
          </v-btn>
        </div>
      </v-card-title>

      <!-- Upload Section -->
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Upload Questions CSV
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form @submit.prevent="uploadFile">
              <v-file-input
                v-model="file"
                label="Choose CSV file"
                accept=".csv"
                outlined
                dense
                prepend-icon="mdi-file-upload"
              />
              <v-btn
                color="primary"
                :disabled="!file || loading"
                type="submit"
                class="mt-2"
              >
                <v-icon left>mdi-upload</v-icon>
                Upload
              </v-btn>
            </v-form>

            <v-alert v-if="message" type="success" class="mt-3" dense>
              {{ message }}
            </v-alert>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="mt-6 mr-5 ml-5">
        <v-text-field
          v-model="search"
          label="Search questions"
          append-icon="mdi-magnify"
          outlined
          clearable
          class="mb-4"
        />
      </div>

      <!-- Data Table -->
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="questions"
          :search="search"
          :loading="loading"
          loading-text="Loading questions..."
          class="elevation-1"
        >
          <!-- Countries as chips -->
          <template v-slot:item.countries="{ item }">
            <v-chip
              v-for="country in item.countries"
              :key="country"
              small
              class="ma-1"
            >
              {{ country }}
            </v-chip>
          </template>

          <!-- Active as Yes/No -->
          <template v-slot:item.isActive="{ item }">
            <v-chip :color="item.isActive ? 'green' : 'red'" dark small>
              {{ item.isActive ? "Active" : "Inactive" }}
            </v-chip>
          </template>

          <!-- Formatted createdAt -->
          <template v-slot:item.createdAt="{ item }">
            {{ formatDate(item.createdAt) }}
          </template>

          <!-- Edit Icon -->
          <template v-slot:item.edit="{ item }">
            <v-icon
              small
              class="mr-2"
              color="primary"
              @click="navigateToEditQuestion(item._id)"
            >
              mdi-pencil
            </v-icon>
          </template>

          <!-- Responses Icon -->
          <template v-slot:item.responses="{ item }">
            <v-icon small color="blue" @click="navigateToResponses(item._id)">
              mdi-chart-pie
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2";

const service = new RestResource();

export default {
  name: "QuestionsList",
  data() {
    return {
      file: null,
      questions: [],
      loading: false,
      message: "",
      search: "",
      headers: [
        { text: "Questions", value: "questions" },
        { text: "Category", value: "category" },
        { text: "Active", value: "isActive" },
        { text: "Countries", value: "countries" },
        { text: "Points", value: "points" },
        { text: "Total Responses", value: "answerCount" },
        { text: "Responses", value: "responses", sortable: false },
        { text: "Edit", value: "edit", sortable: false },
      ],
    };
  },
  created() {
    this.fetchQuestions();
  },
  methods: {
    async fetchQuestions() {
      this.loading = true;
      try {
        this.$setLoader();
        const res = await service.getProfilingQuestions();
        console.log(res);
        this.questions = res.data.questions;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
        this.$disableLoader();
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
    navigateToQuestionForm() {
      this.$router.push({ name: "MobileV2AddProfilingQuestions" });
    },
    navigateToAnalytics() {
      this.$router.push({ name: "MobileV2ProfilingAnalytics" });
    },
    navigateToEditQuestion(id) {
      this.$router.push({ name: "MobileV2ProfilingEdit", params: { id } });
    },

    async uploadFile() {
      try {
        this.loading = true;
        const formData = new FormData();
        formData.append("file", this.file);

        await service.bulkUpload(formData);
      } catch (err) {
        this.message = "❌ Error uploading file: " + err.message;
      } finally {
        this.loading = false;
      }
    },
    navigateToResponses(surveyId) {
      this.$router.push({
        name: "MobileV2ProfilingResponses",
        params: { surveyId },
      });
    },
  },
};
</script>
